import type { Session, User } from '@supabase/supabase-js';
import { create } from 'zustand';

export type AuthStatus = 'loading' | 'authenticated' | 'unauthenticated';

interface AuthState {
  authStatus: AuthStatus;
  session: Session | null;
  user: User | null;
  setSession: (session: Session | null) => void;
  resetAuth: () => void;
}

export const useAuthStore = create<AuthState>()((set) => ({
  authStatus: 'loading',
  session: null,
  user: null,
  setSession: (session) =>
    set({
      session,
      user: session?.user ?? null,
      authStatus: session ? 'authenticated' : 'unauthenticated',
    }),
  resetAuth: () =>
    set({
      session: null,
      user: null,
      authStatus: 'unauthenticated',
    }),
}));
